var modules_9ece3fb3 = {"root":"CardTitle_module_root__a7f033f5","info":"CardTitle_module_info__a7f033f5","subTitle":"CardTitle_module_subTitle__a7f033f5"};
import "../../../../../assets/esm/components/OfferCard/CardWide/components/CardTitle/CardTitle~Bs4-lWyI.css";

export { modules_9ece3fb3 as default };
//# sourceMappingURL=CardTitle.module.scss.js.map
